import axios from 'axios';
import { useQuery, useMutation } from 'react-query';
import { api } from './swaggerApi';
import { CACHE_KEYS, CACHE_TIMES } from '.';
const PREFIX_URL = '/insights_platform/tap_surveys';

export interface TapSurvey {
  is_ep_required: boolean;
  identifier: string;
}

export const get = (identifier: string) =>
  axios.get(`${PREFIX_URL}/${identifier}`);
export const put = (identifier: string, data: Record<string, unknown>) =>
  axios.put(`${PREFIX_URL}/${identifier}`, data);

export const getResultsData = async (tapSurveyIdentifier: string) => {
  const { data } = await axios.get(
    `${PREFIX_URL}/${tapSurveyIdentifier}/results`
  );
  return data;
};

export const getCrossTabData = async (
  identifier: string,
  primary_question_id: string,
  secondary_question_id: string
) => {
  const { data } = await axios.get(
    `${PREFIX_URL}/${identifier}/results/cross_tab_data?primary_question_id=${primary_question_id}&secondary_question_id=${secondary_question_id}`
  );
  return data;
};

export const useUpdateTapSurvey = () => {
  return useMutation(
    async ({ identifier, ...rest }: Record<string, unknown>) => {
      const { data } = await put(identifier as string, rest);
      return data;
    }
  );
};

export const useImportQuestions = (tapSurveyIdentifier: string, opts = {}) => {
  return useMutation(
    async (params: unknown) => {
      return await axios.post(
        `${PREFIX_URL}/${tapSurveyIdentifier}/import_questions`,
        params
      );
    },
    {
      ...opts,
    }
  );
};

export const useTapSurveyQuestionsList = (
  tapSurveyIdentifier: string,
  campaignResultIdentifier?: string
) => {
  return useQuery(
    [CACHE_KEYS.TAP_SURVEY_QUESTIONS, tapSurveyIdentifier],
    async () => {
      const { data } = await api.insightsPlatform.tapSurveysQuestionsListDetail(
        {
          identifier: tapSurveyIdentifier,
          ...(!!campaignResultIdentifier && {
            result_identifier: campaignResultIdentifier,
          }),
        }
      );
      return data.data;
    },
    {
      enabled: !!tapSurveyIdentifier,
      keepPreviousData: true,
      staleTime: CACHE_TIMES.FIVE_MINUTES,
    }
  );
};
